<template>
  <div class="region_selector">
    <div class="current" @click="toggle_region_selector()">
      <svg>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0773 0.105087C16.1503 -0.345643 17.2286 0.734363 16.7774 1.80781L11.1256 15.2525C10.6432 16.4 8.95507 16.1724 8.79328 14.9381L8.39886 11.929C8.16338 10.1325 6.75061 8.71874 4.95545 8.48327L1.94398 8.08825C0.710041 7.9264 0.483078 6.23583 1.63059 5.75379L15.0773 0.105087ZM14.271 2.61278L5.06391 6.48048L5.21516 6.50032C7.90789 6.85353 10.0271 8.9741 10.3803 11.6689L10.4002 11.8208L14.271 2.61278Z"/>
      </svg>
      <span>{{region}}</span>
    </div>
    <div class="list" v-show="show_region_selector_list">
      <div class="item" :class="[{current: region == 'Рязань'}]">
        <a href="https://stp62.ru/lk/main">Рязань</a>
      </div>
      <div class="item" :class="[{current: region == 'Тула'}]">
        <a href="https://71stp.ru/lk/main">Тула</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegionSelector',
  props : {
    hb_qnt : Number
  },
  components: {

  },
  data() {
    return{
      region: "",
      show_region_selector_list: false
    }
  },
  methods : {
    toggle_region_selector : function() {
      this.show_region_selector_list = !this.show_region_selector_list;
    }
  },
  mounted() {
    console.log(this.$route.name);

    if(window.location.origin == 'https://stp62.ru') {
      this.region = "Рязань";
    }
    else if(window.location.origin == 'https://71stp.ru') {
      this.region = "Тула";
    }
    else {
      this.region = "Рязань";
    }
  }
}
</script>

<style scoped>
.region_selector {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: relative;
  margin-right: 8px;
}

.region_selector .current {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.region_selector .current svg {
  width: 17px;
  height: 17px;
}

.region_selector .current:hover {
  color: var(--Blue);
}

.region_selector .current:hover svg path {
  fill: var(--Blue);
}

.region_selector .list {
  display: flex;
  flex-direction: column;
  background: var(--White);
  text-align: left;
  box-shadow: 0 5px 30px rgba(34, 34, 34, .1);
  overflow: hidden;
  max-width: 450px;
  min-width: 220px;
  padding: 8px;
  border-radius: 8px;
  position: absolute;
  z-index: 1;
  top: 25px;
}
.region_selector .list .item {
  display: block;
  padding: 9px 16px 10px 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.region_selector .list .item.current {
  background: #f4f4f4;
  pointer-events: none;
  border-radius: 8px;
}
.region_selector .list a {
  text-decoration: unset;
  color: initial;
}
.region_selector .list a:hover {
  color: var(--Blue);
}
</style>